module.exports = __webpack_public_path__ + "static/media/gallery10.197bc1fa.jpg";